export default "__VITE_ASSET__e134da93__"